import { C8Node } from "csi/typings";
import _AggregateProductMixin from "./_AggregateProductMixin";
import New from "csi/table/New";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";

const ITEM_TYPE_FIELD = "ItemType";
const AGGREGATE_FOOD_PAGE = 1;
const AGGREGATE_FORMULATED_MATERIAL_PAGE = 2;
const AGGREGATE_FOOD_INGREDIENT_PAGE = 3;
const AGGREGATE_PRODUCT_PAGE = 4;

const EC_ITEM_TYPE_STYLE = "ECItemType:Style";
const EC_ITEM_TYPE_MATERIAL = "ECItemType:Material";
const EC_ITEM_TYPE_FOOD = "ECItemType:Food";
const EC_ITEM_TYPE_FORMULATED_MATERIAL = "ECItemType:FormulatedMaterial";
const EC_ITEM_TYPE_FOOD_INGREDIENT = "ECItemType:FoodIngredient";


const NewAffectedItemWizard = declare([New, ActionControllerMixin, _AggregateProductMixin], {
	idWizardResource: "NewAffectedItemWizard",

	/** @property {C8Node[]} _newlyCreatedAffectedItems -  List of newly created AffectedItems */
	_newlyCreatedAffectedItems: null,

	onWizardPageSelect(wizard, page) {
		const itemType = this.m_formData.getFieldValue(ITEM_TYPE_FIELD);
	},

	/**
	 * @override
	 * Disable finish button
	 */
	disableFinish(wizard, page, index) {
		return index==0 || this.m_formData.getSelectedNodes().length <= 0;
	},

	/**
	 * @override
	 * Filter nodes based on the selected product type
	 */
	getWizardViewQuery(wizard, view, index) {
		if (index <= 0) {
			return this.inherited(arguments);
		}

		const typeEnum = this.m_formData.getFieldValue(ITEM_TYPE_FIELD);
		const type = xml.enumGetText(typeEnum);

		const q = new Query();
		q.Node(xml.PROP_TYPE, xml.OP_EQUALS, type);

		switch (typeEnum) {
			case EC_ITEM_TYPE_STYLE:
				q.Attr("IsTemplate", xml.OP_EQUALS, false);
				break;

			case EC_ITEM_TYPE_MATERIAL:
				q.Attr("Hidden", xml.OP_EQUALS, false);
				q.Attr("Special", xml.OP_EQUALS, false);
				break;

			case EC_ITEM_TYPE_FOOD:
			case EC_ITEM_TYPE_FORMULATED_MATERIAL:
				q.Attr("Special", xml.OP_EQUALS, false);
				break;
		}

		return q;
	},

	/**
	 * @override
	 * Pass data into the next page
	 */
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		const fd = this.m_formData;
		const itemType = fd.getFieldValue(ITEM_TYPE_FIELD);
		const nextPageIndex = wizard.getIndexOfPage(nextPage);
		let newPageIndex = 0;

		if (bFinish) {
			return null;
		}

		// Determine the target page
		switch (itemType) {
			case EC_ITEM_TYPE_FOOD:
				newPageIndex = AGGREGATE_FOOD_PAGE;
				break;

			case EC_ITEM_TYPE_FORMULATED_MATERIAL:
				newPageIndex = AGGREGATE_FORMULATED_MATERIAL_PAGE;
				break;

			case EC_ITEM_TYPE_FOOD_INGREDIENT:
				newPageIndex = AGGREGATE_FOOD_INGREDIENT_PAGE;
				break;

			case EC_ITEM_TYPE_STYLE:
			case EC_ITEM_TYPE_MATERIAL:
				newPageIndex = AGGREGATE_PRODUCT_PAGE;
				break;
		}

		// Return the next page until we reach the target page
		if (nextPageIndex != newPageIndex) {
			return wizard.skipToNextPage(nextPage);
		}

		return wizard.setFormDataToPage(nextPage, fd, (newPageIndex > 0));
	},

	/**
	 * @override
	 * Navigate back to first page
	 */
	onPrevPage(wizard, currentPage, prevPage) {
		if (wizard.getIndexOfPage(prevPage) > 0) {
			return wizard.skipToPrevPage(prevPage);
		}

		this.m_formData.resetSelections();
		return this.inherited(arguments);
	},

	/**
	 * @override
	 * ItemType is marked to be taken care on the server side
	 */
	toWriterRequest(fd) {
		this.m_formData.getFieldValue("ItemType", true);
		return this.inherited(arguments);
	},

	/** @override
	 * Store newly created AffectedItems
	 */
	onPublishResponse(response: any): void {
		if (this._newlyCreatedAffectedItems === null) {
			this._newlyCreatedAffectedItems = response.getNodesOfType("AffectedItem");
		}
		this.inherited(arguments);
	},

	/** @override
	 * Get newly created AffectedItems
	 */
	getNewNodes(): C8Node[] {
		if (this._newlyCreatedAffectedItems == null) {
			return [];
		}
		const newNodes:C8Node[] =  [...this._newlyCreatedAffectedItems];
		this._newlyCreatedAffectedItems = null;

		return newNodes;
	},
});

export = NewAffectedItemWizard;